// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"696":"0fd62601","863":"4d3f5b36"}[chunkId] + ".chunk.css";
};